// src/components/ui/dialog/dialog-header.jsx
import * as React from "react";
import { cn } from "../../../lib/utils";

const DialogHeader = ({ className, ...props }) => (
  <div
    className={cn(
      "flex flex-col space-y-1.5 text-center sm:text-left",
      className
    )}
    {...props}
  />
);

DialogHeader.displayName = "DialogHeader";

export { DialogHeader };
